export default [
  {
    label: "Absurdism",
    value: "Absurdism"
  },
  {
    label: "Aestheticism",
    value: "Aestheticism"
  },
  {
    label: "Beat Generation",
    value: "Beat Generation"
  },
  {
    label: "Black Arts Movement",
    value: "Black Arts Movement"
  },
  {
    label: "Cavalier Poets",
    value: "Cavalier Poets"
  },
  {
    label: "Confessionalists",
    value: "Confessionalists"
  },
  {
    label: "Dadaism",
    value: "Dadaism"
  },
  {
    label: "Existentialism",
    value: "Existentialism"
  },
  {
    label: "Expressionism",
    value: "Expressionism"
  },
  {
    label: "Feminism",
    value: "Feminism"
  },
  {
    label: "Imagism",
    value: "Imagism"
  },
  {
    label: "Magical Realism",
    value: "Magical Realism"
  },
  {
    label: "Metaphysical Poets",
    value: "Metaphysical Poets"
  },
  {
    label: "Modernism",
    value: "Modernism"
  },
  {
    label: "Neoclassicism",
    value: "Neoclassicism"
  },
  {
    label: "Naturalism",
    value: "Naturalism"
  },
  {
    label: "New York School",
    value: "New York School"
  },
  {
    label: "Postcolonialism",
    value: "Postcolonialism"
  },
  {
    label: "Postmodernism",
    value: "Postmodernism"
  },
  {
    label: "Pre-Raphaelites",
    value: "Pre-Raphaelites"
  },
  {
    label: "Realism",
    value: "Realism"
  },
  {
    label: "Romanticism",
    value: "Romanticism"
  },
  {
    label: "Socialism / Marxism",
    value: "Socialism / Marxism"
  },
  {
    label: "Surrealism",
    value: "Surrealism"
  },
  {
    label: "Symbolism",
    value: "Symbolism"
  },
  {
    label: "Transcendentalism",
    value: "Transcendentalism"
  }
];
